import { Component, EventEmitter, OnInit, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { KeyboardService } from '../../../keyboard/keyboard.service';

@Component({
  selector: 'form-input',
  styleUrls: ['form-input.component.sass'],
  template: `
    <div class="dynamic-field form-input" [formGroup]="group">
      <mat-form-field appearance="outline">
        <mat-label>{{ config.label }}</mat-label>
        <input
          class="mat-form-field uppercase"
          matInput
          #input
          [attr.placeholder]="config.placeholder"
          [formControlName]="config.name"
          (focus)="keyboardService.onInputFocus(keyboardChange, $event)"
          (ngModelChange)="keyboardService.onInputChange(group.getRawValue(), input)"
        />
      </mat-form-field>
    </div>
  `,
})
export class FormInputComponent implements Field, OnInit {
  config: IFieldConfig;
  group: FormGroup;
  typeCes?: TypeCesEnum | undefined;
  keyboardChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(public keyboardService: KeyboardService) {}

  ngOnInit(): void {
    this.keyboardChange.subscribe((event) => {
      this.group.get(this.config.name)?.setValue(event);
    });
  }

  get typeCesEnum() {
    return TypeCesEnum;
  }
}
